import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedMenu: 'Dashboard',
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    selectMenu: (state, action) => {
      state.selectedMenu = action.payload;
    },
  },
});

export const { selectMenu } = menuSlice.actions;

export default menuSlice.reducer;

